import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';

const Healthcare = () => {
  return (
    <div className="min-h-screen">
      <section className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <Heart className="w-16 h-16 text-[var(--accent-primary)] mx-auto mb-6" />
            <span className="inline-block px-4 py-1 bg-[var(--accent-wash)] text-[var(--accent-text)] rounded-full text-sm font-medium mb-6">Work in Progress</span>
            <h1 className="heading-1 mb-6">Healthcare solutions — in development.</h1>
            <p className="body-large text-[var(--text-secondary)] mb-12">
              Ferntree is exploring responsible applications of AI in healthcare environments. We will publish validated capabilities as they mature.
            </p>
            <Link to="/contact" className="btn-primary">Discuss a Pilot</Link>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Healthcare;